export enum DashboardRemovalUpdateStatusEnum {
    // noinspection JSUnusedGlobalSymbols
    EMAIL = 'EMAIL',
    ERROR = 'ERROR',
    HUMAN = 'HUMAN',
    REQUESTED = 'REQUESTED',
}
